import React, { useState } from 'react'
import {  Col, Container, Form, Row } from 'react-bootstrap'
import PhoneInput from "react-phone-input-2";

function GetIntouch({classes=""}) {
  const [validated, setValidated] = useState(false);

  const handleSubmit = (event) => {
    const form = event.currentTarget;
    if (form.checkValidity() === false) {
      event.preventDefault();
    }

    setValidated(true);
  };
  return (
    <>  
        <style>
            {`
                .inTouch__left { width: calc(100% - 400px); padding: 50px; box-shadow: 0 0 10px rgba(0, 0, 0, 0.1); border-radius: 16px; }
                .inTouch__right { width: 380px; margin-left: 20px; overflow: hidden; border-radius: 16px; }
                .inTouch__right__img { height: 100%; }
                .inTouch__right__img img { height: 100%; object-fit: cover; }
                @media (max-width:1199.98px) { }
                @media (max-width:991.98px) {
                    .inTouch__right, .inTouch__left { width: 100%; margin: 0; }
                    .inTouch__right { order: -1; margin-bottom: 40px; }
                }
                @media (max-width:767.98px) {
                    .inTouch__right { margin-bottom: 30px; }
                    .inTouch__left { padding: 40px 30px; }
                }
                
            `}
        </style>
        <div className={`section-padding inTouch-container pt-0  ${classes}`}>
            <Container>
                <Row className='align-items-center'  data-aos="fade-up">
                    <Col lg={12}>
                        <div className="inTouch__wrapper d-flex flex-wrap">
                            <div className="inTouch__left">
                                <div className="heading">
                                    <h6><span>Get in Touch</span></h6>
                                    <h3>Ready to <span>Get</span> Started?</h3>
                                </div>
                                <div className="inTouch__left__form">
                                    <Form  noValidate validated={validated} onSubmit={handleSubmit}>
                                        <Row>
                                            <Col md={6}>
                                                <Form.Group className='form-group floating-form'>
                                                    <Form.Control type="text" placeholder="" required />
                                                    <span className="floating-label">Enter your name*</span>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className='form-group floating-form'>
                                                    <Form.Control type="email" placeholder="" required />
                                                    <span className="floating-label">Enter your mail*</span>
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className='form-group floating-form'>
                                                    <PhoneInput required
                                                        country={"in"}
                                                        value="Phone No."
                                                    />
                                                </Form.Group>
                                            </Col>
                                            <Col md={6}>
                                                <Form.Group className='form-group floating-form'>
                                                    <Form.Control type="url" placeholder="" required />
                                                    <span className="floating-label">Website Link*</span>
                                                </Form.Group>
                                            </Col>
                                            <Col md={12}>
                                                <Form.Group className='form-group floating-form'>
                                                    <Form.Control as="textarea" placeholder="" required />
                                                    <span className="floating-label">Enter your Message*</span>
                                                </Form.Group>
                                                <Form.Group className='form-group mb-0' >
                                                    <button  className='button default' type="submit" value="Submit Now" >Submit</button>
                                                </Form.Group>
                                            </Col>
                                        </Row>
                                    </Form>
                                </div>
                            </div>
                            <div className="inTouch__right">
                                 <div className="inTouch__right__img">
                                    <img className='d-none d-lg-block' src="../assets/images/contact/getintouch.jpg" alt="" />
                                    <img className='d-lg-none' src="../assets/images/contact/getintouch-mob.jpg" alt="" />
                                 </div>
                            </div>
                        </div>
                    </Col>
                </Row>
            </Container>
        </div>
    </>
  )
}

export default GetIntouch